export class PopularEventStatusHelper {
  static getEventStatus(status: string): string {
    // European view
    let statusText = "";

    if (status != null) {
      switch (status) {
        case "suspended":
          statusText = "Suspended";
          break;

        case "graded":
          statusText = "Closed";
          break;

        case "closed":
          statusText = "Closed";
          break;

        default:
          break;
      }
    }

    return statusText;
  }
}
